import { render } from "./ViewContract.vue?vue&type=template&id=f0873df2"
import script from "./ViewContract.vue?vue&type=script&lang=js"
export * from "./ViewContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__